module.exports = __webpack_public_path__ + "img/seo-content-collapsible-ford.15596269.png";